<div class="p-1">
	<div class="dropdown mt-2" style="width: 100%;">
		<button
			style="width: 100%; text-align: left"
			class="btn btn-lg btn-primary dropdown-toggle box-s"
			type="button"
			id="dropdownMenuButton"
			data-bs-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false"
		>
			<div class="row">
				<div class="col inline-block text-truncate">
					{{ phaseService.phase.title }}
				</div>
				<div class="col-1">
					<i
						class="fa fa-chevron-down float-right"
						style="font-size: 30px"
					></i>
				</div>
			</div>
		</button>
		<div
			style="width: 100%"
			class="dropdown-menu"
			aria-labelledby="dropdownMenuButton"
		>
			<a
				class="dropdown-item"
				(click)="phaseService.setPhase(phase)"
				*ngFor="let phase of this.phases"
				[class.active-menu-item]="phase?.title === phaseService.phase.title"
				>{{ phase?.title }}</a
			>
		</div>
	</div>
</div>
